<template>
  <div class="income-and-expenses-container">
    <Jotform :src="url" :initial-height="1100" />
  </div>
</template>

<script>
import Jotform from '@/components/common/JotForm.vue';

export default {
  components: {
    Jotform,
  },
  computed: {
    url() {
      return process.env.VUE_APP_CUSTOM_THEME_JOTFORMS_INCOME_AND_EXPENSES_URL ?? '';
    },
  },
};
</script>

<style lang="scss" scoped>
.income-and-expenses-container {
  width: 100%;
}
</style>
